import { render } from "./InfoPayment.vue?vue&type=template&id=12e9dcd3&scoped=true"
import script from "./InfoPayment.vue?vue&type=script&lang=js"
export * from "./InfoPayment.vue?vue&type=script&lang=js"

import "./InfoPayment.vue?vue&type=style&index=0&id=12e9dcd3&lang=scss&scoped=true"

import exportComponent from "/home/douglas/Rwi/surefooted-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12e9dcd3"]])

export default __exports__